module.exports = __webpack_public_path__ + "static/undraw_order_a_car_3tww_light-d1dea7815f94d807b111732e45a6f19c.svg";